import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 构建大屏数据展示页面-数据可视化http://datav.jiaminghi.com/guide/scrollRankingBoard.html#config%E5%B1%9E%E6%80%A7
import dataV from '@jiaminghi/data-view'
// 引入全局css
import './assets/scss/style.scss';

import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import 'echarts-gl';
import './utils/filter.js'
import './utils/http.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(dataV);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
